import { useEffect } from 'react';
import { get } from 'lodash';

export const useUpdateMetaTags = ({ seoHeadContent }) => {
  const title = get(seoHeadContent, 'title');
  const description = get(seoHeadContent, 'description');

  useEffect(() => {
    if (title && title !== document.title) {
      document.title = title;
      document.querySelector("meta[name='title']")?.setAttribute('content', title);
      document.querySelector("meta[name='description']")?.setAttribute('content', description);
    }
  }, [title, description]);
};
